<div class="container mb-sm-3 my-5">
  <div class="error-container text-center">
    <img src="../../../../assets/images/no-data.png" alt="No data" class="error-image mb-4">
    <p class="lead">Oops! No data found.</p>
    <a role="button" (click)="back()" class="btn btn-danger text-white mt-3">Go Back</a>
  </div>
</div>
